<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <!-- Decorative top seal -->
    <img src="@/assets/sello.avif" alt="Decorative seal" class="sello-superior" />

    <!-- Title -->
    <h2 ref="tituloRef" class="mesa-titulo animate-item">
      <span class="script">Gift</span> 
    </h2>

    <!-- Description -->
    <p ref="descripcionRef" class="mesa-descripcion animate-item">
      For us, the best gift is your presence, but if you would like to contribute to our honeymoon, here is an option for you.<br />
      <strong></strong>
    </p>

    <!-- Decorative envelope -->
    <img ref="sobreRef" src="@/assets/SOBRE.avif" class="sobre-icono animate-item" alt="Decorative envelope" />

    <p ref="notaRef" class="nota-extra animate-item">
      Envelope shower<br> on the day of the event.
    </p>
  </div>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)
    const elementosAnimados = ref([])

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value = regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = Array.from(elementosAnimados.value).indexOf(entry.target)
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 40, scale: 0.95 },
                {
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  duration: 0.8,
                  delay: index * 0.2,
                  ease: 'power2.out',
                }
              )
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: 0.3 })

        elementosAnimados.value.forEach((el) => observer.observe(el))
      })
    })

    return {
      regalosRef
    }
  }
}
</script>

<style scoped>
.mesa-regalos-section {
  background-color: #3f4d3d;
  color: #f1e9dc;
  font-family: 'Playfair Display', serif;
  width: 90%;
  margin: 0 auto;
  border-radius: 80px 0 0 80px;
  padding: 50px 30px 60px;
  position: relative;
  text-align: center;
  top: 20px;
}

.sello-superior {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: auto;
  z-index: 2;
}

.mesa-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: white;

 margin-right: -10px;
    font-family: 'subtitulos';
}

.script {
  font-family: 'corinthia';
  font-size: 2.4rem;
  color: #e7d8cb;
  font-weight: normal;
  margin-left: 8px;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  letter-spacing: 1px;
  color: #e2d8cb;
  margin-bottom: 40px;
  text-transform: none;
}

.evento-liverpool {
  margin-bottom: 40px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #f1e9dc;
}

.icono-evento {
  width: 40px;
  margin-bottom: 10px;
  filter: brightness(0.95);
}

.btn-liverpool {
  background-color: #b8ae98;
  color: white;
  padding: 6px 20px;
  border-radius: 20px;
  display: inline-block;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  margin-top: 8px;
  letter-spacing: 1px;
}

.mesa-carrusel {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin-bottom: 40px;
}

.mesa-tarjeta {
  background-color: #5e6a5a;
  padding: 25px 30px;
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  width: 100%;
}

.mesa-lugar {
  font-family: 'corinthia';
  font-size: 26px;
  color: #e0cba0;
  margin-bottom: 6px;
}

.mesa-numero {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #f6f2e6;
}

.sobre-icono {
  width: 90px;
  height: auto;
  margin: 40px 0 20px;
}

.nota-extra {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #f1e9dc;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.animate-item {
  opacity: 0;
  transform: translateY(40px);
}
</style>
